/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Calm_Crocodile_LinkInputs */

const es_free_calm_crocodile_link = /** @type {(inputs: Free_Calm_Crocodile_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const gl_free_calm_crocodile_link = /** @type {(inputs: Free_Calm_Crocodile_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const en_free_calm_crocodile_link = /** @type {(inputs: Free_Calm_Crocodile_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Free_Calm_Crocodile_LinkInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const free_calm_crocodile_link = /** @type {((inputs?: Free_Calm_Crocodile_LinkInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Calm_Crocodile_LinkInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_free_calm_crocodile_link(inputs)
	if (locale === "en") return en_free_calm_crocodile_link(inputs)
	return es_free_calm_crocodile_link(inputs)
});